import { render } from "./Mantenimientolist.vue?vue&type=template&id=80116b56"
import script from "./Mantenimientolist.vue?vue&type=script&lang=js"
export * from "./Mantenimientolist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__